export default __webpack_public_path__ + "media/zurb/img/home/facebook-logo-b57345d8450588ae2cada304c2120adb.png";